<template>
  <div class="contain" v-loading="loading">
    <div class="contain">
      <div class="logWin">
        <el-form ref="form" :model="form">
          <h1 class="title">{{ sitename }} · 登录</h1>
          <el-form-item prop="user" :rules="$rules.required">
            <el-input
              type="text"
              v-model="form.user"
              placeholder="请输入账号"
            />
          </el-form-item>
          <el-form-item prop="pass" :rules="$rules.required">
            <el-input
              type="password"
              v-model="form.pass"
              placeholder="请输入密码"
              :show-password="true"
            />
          </el-form-item>
          <el-button plain type="primary" @click="handleSubmit">登录</el-button>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <span> ⋅ </span>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
        <span>{{ copyright }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginView",
  data() {
    return {
      loading: false,
      copyright: "",
      form: {
        user: "",
        pass: "",
      },
    };
  },
  created() {
    this.sitename = window.global.sitename;
    this.copyright = window.global.copyright;
  },
  mounted() {
    document.title = this.sitename;
  },
  methods: {
    handleSubmit() {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true;
          setTimeout(() => {
            this.$message.warning("账号或密码不正确");
            this.loading = false;
          }, 3000);
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
body {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
}

body {
  margin: 0em;
  padding: 0em;
  overflow: auto;
  text-align: center;
  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%);
}
.contain {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.logWin {
  zoom: 1.3;
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  box-shadow: 0 0 8px #ffe79c;
  padding: 30px 55px;
}

.title {
  margin-bottom: 50px;
}

.footer,
.footer a {
  color: rgb(180, 133, 255);
}
</style>
